
export default function Avatar({initials, size, color, style}){

    let sz = (size || 40);
    let s = sz + 'px';
    let fs = Math.round(sz / 2.2) + 'px';
    
    const css = {
        width: s,
        minWidth: s,
        maxWidth: s,
        height: s,
        minHeight: s,
        maxHeight: s,
        backgroundColor: color || 'lightblue',
        color: 'white',
        fontSize: fs,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
    };

    Object.assign(css, style || {})

    return <div style={css}><span>{initials}</span></div>
}